/*
 * @Description: 订单管理
 * @Author: 杨志航
 * @Date: 2026-05-08 17:02:43
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import QuickRefund from './QuickRefund'
import TransferOrder from './TransferOrder'
import './assets/style.scss'

const Index = ({ match, history }) => {
  return (
    <div>
      <Switch>
        <Route path={match.path + '/quickRefund'} component={QuickRefund} />
        <Route path={match.path + '/transferOrder'} component={TransferOrder} />
        <Route component={QuickRefund} />
      </Switch>
    </div>
  )
}

export default Index